import React from "react";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import PrimaryTableCell from "app/Components/Tables/PrimaryTableCell";

const MUITourneyTableHeader = () => (
  <TableHead>
    <TableRow>
      <PrimaryTableCell align="center" key="gameName">
        Name
      </PrimaryTableCell>
      <PrimaryTableCell align="center" key="Game">
        Game
      </PrimaryTableCell>
      <PrimaryTableCell align="center" key="Buyin">
        Buy-in
      </PrimaryTableCell>
      <PrimaryTableCell align="center" key="Fee">
        Fee
      </PrimaryTableCell>
      <PrimaryTableCell align="center" key="Status/StartTime">
        Status
      </PrimaryTableCell>
      <PrimaryTableCell align="center" key="Distance">
        Distance
      </PrimaryTableCell>
      <PrimaryTableCell align="center" key="Number">
        Registrants
      </PrimaryTableCell>
      <PrimaryTableCell align="center" key="Options">
        Options
      </PrimaryTableCell>
    </TableRow>
  </TableHead>
);

export default MUITourneyTableHeader;
